// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_mainAreaImage__7tvdX {
    width: 100%;
    background: url(https://source.unsplash.com/random/1920x1080/?white);
}

.home_mainAreaOverlay__0RNgR {
    height: 100%;
    width: 100%;
    background: rgb(255, 255, 255);
    background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.9710259103641457) 29%, rgba(255, 255, 255, 0.14469537815126055) 100%);
}

.home_mainContent__yL677 {
    margin-top: 1em;
    display: flex;
    gap: 20px;
    flex-direction: row;
}

#home_wrapper__s0Q38 {
    margin-right: auto;
    margin-left: auto;
    max-width: 1360px;
    padding: 20px;
}

.home_mainContent__yL677 h1 {
    color: #fff;
    font-size: 48px;
    font-weight: 600;
    border-radius: 20px;
    padding: 10px 20px;
    display: inline;
    background: linear-gradient(270deg, #00b9ff, #0076ff);
    background-size: 400% 400%;
    animation: home_animateBg__KCNUG 9s linear infinite;
    background-image: linear-gradient(90deg, #020066, #229ca5, #00bfff, #020066, #229ca5);
    background-size: 400% 100%;
}

.home_mainContent__yL677 #home_flex__xQ4jb {
    flex: 1 1;
}

@keyframes home_animateBg__KCNUG {
    0% {
        background-position: 0% 0%;
    }

    100% {
        background-position: 100% 0%;
    }
}

.home_mainContent__yL677 p {
    font-size: 18px;
    margin-top: 28px;
    line-height: 28px;
    letter-spacing: 0.5px;
    font-weight: 500;
}

.home_mainContent__yL677 a {
    text-decoration: none;
    color: #fff;
    margin-top: 20px;
    display: inline-block;
    font-size: 18px;
    font-weight: 700;
    background: #222;
    padding: 10px 20px;
    border-radius: 10px;
    transition: all ease 300ms;
}

.home_mainContent__yL677 a:hover {
    background: #000;
}

.home_seprator__Pb4SI {
    margin-top: 60px;
}

.home_seprator__Pb4SI h1 {
    font-size: 36px;
    font-weight: 500;
}

.home_seprator__Pb4SI span {
    font-size: 36px;
    font-weight: 700;
    color: #0076ff;
}

.home_aboutArea__C0GPU {
    display: flex;
    flex-direction: row;
    gap: 20px;
    margin-top: 4rem;
}

.home_aboutArea__C0GPU #home_flex__xQ4jb {
    padding: 10px 10px;
    width: 100%;
    flex: 1 1;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2em;
    background: rgba(248, 248, 248, 0.6);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    border: 1px solid #eee;
    transition: all ease 300ms;
}

.home_aboutArea__C0GPU #home_flex__xQ4jb:hover {
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
    border: 1px solid rgba(255, 255, 255, 0.18);
    background-color: rgb(45, 208, 177, 0.14);
}

.home_aboutArea__C0GPU .home_iconBox__lGn-K {
    color: #fff;
    border-radius: 100%;
    box-shadow: 1px 1px 15px #888;
    font-size: 2em;
}

.home_aboutArea__C0GPU h1 {
    font-size: 21px;
    font-weight: 800;
    font-family: sans-serif;
    color: #222;
}

.home_aboutArea__C0GPU p {
    color: #444;
    font-size: 18px;
    font-weight: 600;
}

#home_gradientBlue__RzKog {
    background: hsla(213, 67%, 31%, 1);
    background: linear-gradient(0deg, hsla(213, 67%, 31%, 1) 0%, hsla(203, 100%, 36%, 1) 100%);
    background: -webkit-linear-gradient(0deg, hsla(213, 67%, 31%, 1) 0%, hsla(203, 100%, 36%, 1) 100%);
    filter: progid: DXImageTransform.Microsoft.gradient(startColorstr="#1A4982", endColorstr="#0072B8", GradientType=1);
}

#home_gradientBlack__45k2a {
    background: hsla(0, 0%, 22%, 1);
    background: linear-gradient(90deg, hsla(0, 0%, 22%, 1) 0%, hsla(0, 0%, 0%, 1) 100%);
    background: -webkit-linear-gradient(90deg, hsla(0, 0%, 22%, 1) 0%, hsla(0, 0%, 0%, 1) 100%);
    filter: progid: DXImageTransform.Microsoft.gradient(startColorstr="#393939", endColorstr="#000000", GradientType=1);
}

#home_gradientGreen__dX65V {
    background: hsla(155, 72%, 36%, 1);
    background: linear-gradient(0deg, hsla(155, 72%, 36%, 1) 0%, hsla(154, 40%, 25%, 1) 100%);
    background: -webkit-linear-gradient(0deg, hsla(155, 72%, 36%, 1) 0%, hsla(154, 40%, 25%, 1) 100%);
    filter: progid: DXImageTransform.Microsoft.gradient(startColorstr="#1A9F67", endColorstr="#275A44", GradientType=1);
}


/* Conpany Description Profile */

#home_superContainer__NN-5N {
    margin-right: auto;
    margin-left: auto;
    max-width: 1360px;
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    gap: 40px;
    width: auto;
    height: auto;
}
.home_superContainerSon__Lukbd {
    flex: 1 1;

}
.home_left_container__sNcs1 {
    display: flex;
    flex-direction: column;
    gap: 3em;
    /* justify-content: space-around; */
}

.home_superContainerSon__Lukbd h1 {
    font-size: 30px;
    font-weight: 800;
    color: #222;
    margin-top: 1em;
    margin-bottom: 3rem;
}

.home_superContainerSon__Lukbd p {
    align-content: center;
    font-weight: 400;
    padding: 0 20px;
    text-align: justify;
    line-height: 1.8em;
    font-size: 17px;
}

.home_superContainerSon__Lukbd label {
    margin-left: 1em;
    border-radius: 1em;
    padding: 9px;
    color: #fff;
    border: 3px solid #2dd0b1;
    background-image: linear-gradient(30deg, #2dd0b1 50%, transparent 50%);
    background-size: 500px;
    font-size: 16px;
    background-repeat: no-repeat;
    background-position: 0%;
    transition: background 500ms ease-in-out;
}

.home_superContainerSon__Lukbd label:hover{
    background-position: 100%;
    color: #2dd0b1;
    cursor: pointer;
}


.home_h1tag__b\\+-NE {
    display: flex;
    justify-content: center;
}



.home_right_container__UGJhP {
    padding: 1em;
}

.home_rightImage__zcJuf {
    height: 38em;
    width: 100%;
    border-radius: 10px;
}



@media (max-width: 992px) {
    .home_mainContent__yL677 {
        margin-top: 1em;
        display: flex;
        gap: 20px;
        flex-direction: column;
    }
    .home_aboutArea__C0GPU {
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin-top: 20px;
    }
    #home_superContainer__NN-5N {
        margin-right: auto;
        margin-left: auto;
        max-width: 1360px;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        gap: 1em;
        width: auto;
        height: auto;
    }
    .home_mainContent__yL677 h1 {
        font-size: 26px;
        }
}`, "",{"version":3,"sources":["webpack://./src/core/css/home.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,oEAAoE;AACxE;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,8BAA8B;IAC9B,0JAA0J;AAC9J;;AAEA;IACI,eAAe;IACf,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,qDAAqD;IACrD,0BAA0B;IAC1B,mDAAuC;IACvC,qFAAqF;IACrF,0BAA0B;AAC9B;;AAEA;IACI,SAAO;AACX;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAO;IACP,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,oCAAoC;IACpC,2BAA2B;IAC3B,mCAAmC;IACnC,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,gDAAgD;IAChD,2CAA2C;IAC3C,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,0FAA0F;IAE1F,kGAAkG;IAClG,mHAAmH;AACvH;;AAEA;IACI,+BAA+B;IAC/B,mFAAmF;IAEnF,2FAA2F;IAC3F,mHAAmH;AACvH;;AAEA;IACI,kCAAkC;IAClC,yFAAyF;IAEzF,iGAAiG;IACjG,mHAAmH;AACvH;;;AAGA,gCAAgC;;AAEhC;IACI,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,SAAS;IACT,WAAW;IACX,YAAY;AAChB;AACA;IACI,SAAO;;AAEX;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,yBAAyB;IAEzB,sEAAsE;IACtE,sBAAsB;IACtB,eAAe;IACf,4BAA4B;IAC5B,uBAAuB;IAEvB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,uBAAuB;AAC3B;;;;AAIA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;;;AAIA;IACI;QACI,eAAe;QACf,aAAa;QACb,SAAS;QACT,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,gBAAgB;IACpB;IACA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,iBAAiB;QACjB,aAAa;QACb,aAAa;QACb,sBAAsB;QACtB,6BAA6B;QAC7B,QAAQ;QACR,WAAW;QACX,YAAY;IAChB;IACA;QACI,eAAe;QACf;AACR","sourcesContent":[".mainAreaImage {\n    width: 100%;\n    background: url(https://source.unsplash.com/random/1920x1080/?white);\n}\n\n.mainAreaOverlay {\n    height: 100%;\n    width: 100%;\n    background: rgb(255, 255, 255);\n    background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.9710259103641457) 29%, rgba(255, 255, 255, 0.14469537815126055) 100%);\n}\n\n.mainContent {\n    margin-top: 1em;\n    display: flex;\n    gap: 20px;\n    flex-direction: row;\n}\n\n#wrapper {\n    margin-right: auto;\n    margin-left: auto;\n    max-width: 1360px;\n    padding: 20px;\n}\n\n.mainContent h1 {\n    color: #fff;\n    font-size: 48px;\n    font-weight: 600;\n    border-radius: 20px;\n    padding: 10px 20px;\n    display: inline;\n    background: linear-gradient(270deg, #00b9ff, #0076ff);\n    background-size: 400% 400%;\n    animation: animateBg 9s linear infinite;\n    background-image: linear-gradient(90deg, #020066, #229ca5, #00bfff, #020066, #229ca5);\n    background-size: 400% 100%;\n}\n\n.mainContent #flex {\n    flex: 1;\n}\n\n@keyframes animateBg {\n    0% {\n        background-position: 0% 0%;\n    }\n\n    100% {\n        background-position: 100% 0%;\n    }\n}\n\n.mainContent p {\n    font-size: 18px;\n    margin-top: 28px;\n    line-height: 28px;\n    letter-spacing: 0.5px;\n    font-weight: 500;\n}\n\n.mainContent a {\n    text-decoration: none;\n    color: #fff;\n    margin-top: 20px;\n    display: inline-block;\n    font-size: 18px;\n    font-weight: 700;\n    background: #222;\n    padding: 10px 20px;\n    border-radius: 10px;\n    transition: all ease 300ms;\n}\n\n.mainContent a:hover {\n    background: #000;\n}\n\n.seprator {\n    margin-top: 60px;\n}\n\n.seprator h1 {\n    font-size: 36px;\n    font-weight: 500;\n}\n\n.seprator span {\n    font-size: 36px;\n    font-weight: 700;\n    color: #0076ff;\n}\n\n.aboutArea {\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n    margin-top: 4rem;\n}\n\n.aboutArea #flex {\n    padding: 10px 10px;\n    width: 100%;\n    flex: 1;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 2em;\n    background: rgba(248, 248, 248, 0.6);\n    backdrop-filter: blur(14px);\n    -webkit-backdrop-filter: blur(14px);\n    border: 1px solid #eee;\n    transition: all ease 300ms;\n}\n\n.aboutArea #flex:hover {\n    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);\n    border: 1px solid rgba(255, 255, 255, 0.18);\n    background-color: rgb(45, 208, 177, 0.14);\n}\n\n.aboutArea .iconBox {\n    color: #fff;\n    border-radius: 100%;\n    box-shadow: 1px 1px 15px #888;\n    font-size: 2em;\n}\n\n.aboutArea h1 {\n    font-size: 21px;\n    font-weight: 800;\n    font-family: sans-serif;\n    color: #222;\n}\n\n.aboutArea p {\n    color: #444;\n    font-size: 18px;\n    font-weight: 600;\n}\n\n#gradientBlue {\n    background: hsla(213, 67%, 31%, 1);\n    background: linear-gradient(0deg, hsla(213, 67%, 31%, 1) 0%, hsla(203, 100%, 36%, 1) 100%);\n    background: -moz-linear-gradient(0deg, hsla(213, 67%, 31%, 1) 0%, hsla(203, 100%, 36%, 1) 100%);\n    background: -webkit-linear-gradient(0deg, hsla(213, 67%, 31%, 1) 0%, hsla(203, 100%, 36%, 1) 100%);\n    filter: progid: DXImageTransform.Microsoft.gradient(startColorstr=\"#1A4982\", endColorstr=\"#0072B8\", GradientType=1);\n}\n\n#gradientBlack {\n    background: hsla(0, 0%, 22%, 1);\n    background: linear-gradient(90deg, hsla(0, 0%, 22%, 1) 0%, hsla(0, 0%, 0%, 1) 100%);\n    background: -moz-linear-gradient(90deg, hsla(0, 0%, 22%, 1) 0%, hsla(0, 0%, 0%, 1) 100%);\n    background: -webkit-linear-gradient(90deg, hsla(0, 0%, 22%, 1) 0%, hsla(0, 0%, 0%, 1) 100%);\n    filter: progid: DXImageTransform.Microsoft.gradient(startColorstr=\"#393939\", endColorstr=\"#000000\", GradientType=1);\n}\n\n#gradientGreen {\n    background: hsla(155, 72%, 36%, 1);\n    background: linear-gradient(0deg, hsla(155, 72%, 36%, 1) 0%, hsla(154, 40%, 25%, 1) 100%);\n    background: -moz-linear-gradient(0deg, hsla(155, 72%, 36%, 1) 0%, hsla(154, 40%, 25%, 1) 100%);\n    background: -webkit-linear-gradient(0deg, hsla(155, 72%, 36%, 1) 0%, hsla(154, 40%, 25%, 1) 100%);\n    filter: progid: DXImageTransform.Microsoft.gradient(startColorstr=\"#1A9F67\", endColorstr=\"#275A44\", GradientType=1);\n}\n\n\n/* Conpany Description Profile */\n\n#superContainer {\n    margin-right: auto;\n    margin-left: auto;\n    max-width: 1360px;\n    padding: 20px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    gap: 40px;\n    width: auto;\n    height: auto;\n}\n.superContainerSon {\n    flex: 1;\n\n}\n.left_container {\n    display: flex;\n    flex-direction: column;\n    gap: 3em;\n    /* justify-content: space-around; */\n}\n\n.superContainerSon h1 {\n    font-size: 30px;\n    font-weight: 800;\n    color: #222;\n    margin-top: 1em;\n    margin-bottom: 3rem;\n}\n\n.superContainerSon p {\n    align-content: center;\n    font-weight: 400;\n    padding: 0 20px;\n    text-align: justify;\n    line-height: 1.8em;\n    font-size: 17px;\n}\n\n.superContainerSon label {\n    margin-left: 1em;\n    border-radius: 1em;\n    padding: 9px;\n    color: #fff;\n    border: 3px solid #2dd0b1;\n    background-image: -webkit-linear-gradient(30deg, #2dd0b1 50%, transparent 50%);\n    background-image: linear-gradient(30deg, #2dd0b1 50%, transparent 50%);\n    background-size: 500px;\n    font-size: 16px;\n    background-repeat: no-repeat;\n    background-position: 0%;\n    -webkit-transition: background 500ms ease-in-out;\n    transition: background 500ms ease-in-out;\n}\n\n.superContainerSon label:hover{\n    background-position: 100%;\n    color: #2dd0b1;\n    cursor: pointer;\n}\n\n\n.h1tag {\n    display: flex;\n    justify-content: center;\n}\n\n\n\n.right_container {\n    padding: 1em;\n}\n\n.rightImage {\n    height: 38em;\n    width: 100%;\n    border-radius: 10px;\n}\n\n\n\n@media (max-width: 992px) {\n    .mainContent {\n        margin-top: 1em;\n        display: flex;\n        gap: 20px;\n        flex-direction: column;\n    }\n    .aboutArea {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n        margin-top: 20px;\n    }\n    #superContainer {\n        margin-right: auto;\n        margin-left: auto;\n        max-width: 1360px;\n        padding: 20px;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-around;\n        gap: 1em;\n        width: auto;\n        height: auto;\n    }\n    .mainContent h1 {\n        font-size: 26px;\n        }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainAreaImage": `home_mainAreaImage__7tvdX`,
	"mainAreaOverlay": `home_mainAreaOverlay__0RNgR`,
	"mainContent": `home_mainContent__yL677`,
	"wrapper": `home_wrapper__s0Q38`,
	"animateBg": `home_animateBg__KCNUG`,
	"flex": `home_flex__xQ4jb`,
	"seprator": `home_seprator__Pb4SI`,
	"aboutArea": `home_aboutArea__C0GPU`,
	"iconBox": `home_iconBox__lGn-K`,
	"gradientBlue": `home_gradientBlue__RzKog`,
	"gradientBlack": `home_gradientBlack__45k2a`,
	"gradientGreen": `home_gradientGreen__dX65V`,
	"superContainer": `home_superContainer__NN-5N`,
	"superContainerSon": `home_superContainerSon__Lukbd`,
	"left_container": `home_left_container__sNcs1`,
	"h1tag": `home_h1tag__b+-NE`,
	"right_container": `home_right_container__UGJhP`,
	"rightImage": `home_rightImage__zcJuf`
};
export default ___CSS_LOADER_EXPORT___;
